/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// redux
import { useSelector, useDispatch } from 'react-redux';
import { updateCurrentPage } from '../../../../../../state/slices/app';
// material
import { Icon } from '@insticator/insticator-ui';
// styles
import injectSheet from 'react-jss';
import styles from './menuitem_styles';



/* ========== ~~~~~~~~~~ MENU ITEM ~~~~~~~~~~ ========== */
const MenuItem = injectSheet(styles)((props) => {
	const dispatch = useDispatch();
	const currentPage = useSelector(state => state.app.currentPage);
	const handleActiveState = () => currentPage.includes(props.route);
	const handleRoute = () => dispatch(updateCurrentPage(props.route));
	const handleOnClick = () => !!props.handleOnClick() ? props.handleOnClick() : null;

	return (
		<div 
			className={`${props.classes.menuitem} menuitem isActive-${!props.route ? false : handleActiveState()} isDisabled-${props.disabled}`} 
			onClick={!props.route ? handleOnClick : handleRoute}
		>
			<Icon name={props.icon} animation={'none'} />
			<div className={`text`}>{props.text}</div>
		</div>
	);
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default MenuItem;
